import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import ChamadoDetalharLayout from '@/features/chamados/layouts/chamado-detalhar-layout'
import ChamadoListarLayout from '@/features/chamados/layouts/chamado-listar-layout'

const ChamadoListarPage = React.lazy(
  () => import('@/features/chamados/pages/chamado-listar'),
)

const ChamadoDetalharPage = React.lazy(
  () => import('@/features/chamados/pages/chamado-detalhar'),
)

const ChamadoRelatorioTecnicoPage = React.lazy(
  () => import('@/features/chamados/pages/chamado-relatorio-tecnico'),
)

const ChamadoListarMeusPage = React.lazy(
  () => import('@/features/chamados/pages/chamado-listar-meus'),
)

const ChamadoItensPage = React.lazy(
  () => import('@/features/chamados/pages/chamado-itens'),
)

export default function Component() {
  return (
    <Routes>
      <Route path="" element={<ChamadoListarLayout />}>
        <Route path="todos" element={<ChamadoListarPage />} />
        <Route path="meus-chamados" element={<ChamadoListarMeusPage />} />
      </Route>
      <Route path=":callId" element={<ChamadoDetalharLayout />}>
        <Route path="detalhes" element={<ChamadoDetalharPage />} />
        <Route path="tecnico" element={<ChamadoRelatorioTecnicoPage />} />
        <Route path="produtos" element={<ChamadoItensPage />} />
      </Route>
      <Route index element={<Navigate to="todos" />} />
    </Routes>
  )
}
